import { createFileRoute } from '@tanstack/react-router'

import { HolidaysPage } from '@/features/leave/pages/HolidaysPage'

export const Route = createFileRoute('/_authenticated/leave/config/holidays')({
  component: HolidaysPage,
})
